export default __webpack_public_path__ + "static/favicon-wilde-65a20f31f7e099c9af708470dbee5cf3.png";